import DataContainer from 'Components/UI/DataContainer';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  TaxStrategyDetailsSkeleton,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsSkeleton';
import TaxStrategyDetailsMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsMetaOverride';
import {
  TaxStrategyDetailsLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsLayout';

const TaxStrategyDetailsContainer = ({
  currentGoalDetailResource, onBack,
}) => {
  return (
    <DataContainer
      component={MetaResourceRenderer}
      componentProps={{
        LayoutProps: {
          showBackButton: true,
          onBack: () => onBack(),
          backLabel: 'Back to all goals',
        },
        metaOverrideSet: TaxStrategyDetailsMetaOverride,
        layout: TaxStrategyDetailsLayout,
        resource: currentGoalDetailResource,
      }}
      skeleton={TaxStrategyDetailsSkeleton}
    />
  );
};

TaxStrategyDetailsContainer.defaultProps = {
  onBack: noop,
};

TaxStrategyDetailsContainer.propTypes = {
  currentGoalDetailResource: PropTypes.instanceOf(fr.Resource).isRequired,
  onBack: PropTypes.func,
};

export default TaxStrategyDetailsContainer;
